import { graphql } from '@/__generated__';
import { useQueryStable } from '../useQueryStable';

type Result = ReturnType<typeof useColumnLineage>[0];
type ColumnLineageResponse = NonNullable<Result['data']>;
export type ColumnLineageNode = NonNullable<
  ColumnLineageResponse['column']['lineage']
>[number];

export const GetColumnLineage = graphql(/* GraphQL */ `
  query Column(
    $environmentId: BigInt!
    $nodeUniqueId: String!
    $filters: ColumnLineageFilter
  ) {
    column(environmentId: $environmentId) {
      lineage(nodeUniqueId: $nodeUniqueId, filters: $filters) {
        accountId
        environmentId
        error
        errorCategory
        isError
        name
        nodeUniqueId
        parentColumns
        childColumns
        projectId
        relationship
        runId
        isPrimaryKey
        uniqueId
        transformationType
        dependentProjects {
          dbtCoreProject
          projectId
          defaultEnvironmentId
          dependentColumnsCount
        }
      }
    }
  }
`);

type ColumnLineageProps = {
  environmentId: number | null | undefined;
  nodeUniqueId?: string | null;
  columnName?: string | null;
  isError?: boolean | null;
  pause?: boolean;
};

export const useColumnLineage = ({
  environmentId,
  nodeUniqueId,
  columnName,
  isError,
  pause,
}: ColumnLineageProps) => {
  const query = useQueryStable({
    query: GetColumnLineage,
    variables: {
      environmentId: environmentId!,
      nodeUniqueId: nodeUniqueId || '',
      filters: {
        columnName: columnName || null,
        isError: isError ?? null,
        maxDepth: null,
      },
    },
    pause: pause || !environmentId || !nodeUniqueId,
  });
  return query;
};
